var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 55,
    viewBox: "0 0 76 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_55_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8417 29.972C18.2389 27.9367 20.9013 6.14541 22.712 6.86968C24.0282 7.39617 24.4907 11.6134 25.0014 12.7805C26.1657 15.4418 27.5528 18.3409 29.3721 20.5646C33.1686 25.2047 32.3905 22.0983 35.4911 19.4407C37.1075 18.0552 38.7714 15.2142 39.9867 13.4466C41.827 10.7697 43.8868 8.17095 45.9392 5.66253C50.0524 0.635186 48.9707 11.9302 50.0601 14.6537C51.5762 18.4438 52.3079 21.8801 52.3079 25.851C52.3079 27.8734 51.3161 34.2479 52.3495 29.5974C54.358 20.5593 59.6611 13.8135 65.0454 6.16204C65.475 5.55158 68.3027 1.46298 69.3745 2.41572C70.1738 3.12622 69.541 7.24072 69.541 8.24333C69.541 16.846 69.541 25.4487 69.541 34.0513C69.541 35.6017 70.7032 43.4621 69.541 44.6243C69.0935 45.0717 68.5154 43.8792 68.0425 43.4588C67.3454 42.8391 66.4731 42.601 65.7947 41.9602C61.1068 37.5328 52.81 37.0194 46.7301 36.7154C38.2512 36.2914 30.1395 35.2169 21.5881 35.2169C16.3432 35.2169 11.0984 35.2169 5.85352 35.2169",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_55_2",
    x: 0.353516,
    y: 0.772461,
    width: 75.2039,
    height: 53.4512,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_55_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_55_2",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.abba19917b5e1bbe806beeb7e7eed1e2.svg";
export { ForwardRef as ReactComponent };